import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import { translate } from "react-i18next";
import RoleManager from '../roleManager/RoleManager';
import ProjectManager from './projectManager/ProjectManager';
import { modalInstance } from './../../../../../admin/Admin';
import messageManager from '../../../../../../utilities/messageManager';
import loading from '../../../../../../utilities/loading';
import DefaultButton from './../../../../../../components/DefaultButton';

const Table = styled.table`
    width: 80%;
    height: calc(100% - 4px);
    border-collapse: collapse;
    th {
        text-align: left;
        border-bottom: 2px solid #265a9c;
    };
    tr {
        font-size: 15px;
    };
    tr:last-child {
        border-bottom: 2px solid #265a9c;
        padding-bottom: 10px;
    };
    tr:last-child>td {
        padding-bottom: 10px;
    };
    td {
        padding: 10px 0 0 10px;
    };
    div {
        display: flex;
        text-align: left;
        align-items: flex-start;
    };
`;

class UserList extends React.Component {
    removeUser(userId) {
        const { BASE_URL, axiosInstance, t, getUsers } = this.props;
        loading.start();

        axiosInstance.put(`${BASE_URL}/account/archive/${userId}`)
            .then((response) => {
                getUsers();
                messageManager.show({
                    type: 'info',
                    text: t('User deleted'),
                });
                loading.stop();
            })
            .catch((error) => {
                messageManager.show({
                    type: 'error',
                    text: t(error.response.data ? error.response.data : t('Error occured while deleting user')),
                });
                this.setState({ createBtnDisabled: false });
                loading.stop();
            });
    }

    customizeDeleteModalWindow(user) {
        const { t } = this.props;
        const confirmCallback = () => {
            this.removeUser(user.id);
        }
        const config = {
            title: t('Do you really want to delete user') + '?',
            content: <p>{t('Do you really want to delete user')} <b>{user.userName}</b>?</p>,
            confirmCallback: confirmCallback,
            confirmBtnVisible: true,
            cancelBtnVisible: true,
            confirmBtnText: t('Delete'),
            closeOnConfirm: true,
            type: 'warning',
        }
        modalInstance.customize(config);
    }

    renderRow(user, projects) {
        const { getProjects, getUsers, t } = this.props;
        return (
            <tr key={`${user.userName}_row`}>
                <td>{user.userName}</td>
                <RoleManager
                    key={`${user.userName}_role_row`}
                    user={user}
                    getUsers={getUsers}
                />
                <td>
                    <div>
                        <ProjectManager
                            getProjects={getProjects}
                            projects={projects}
                            user={user}
                        />
                    </div>
                </td>
                <td>
                    <div>
                        <DefaultButton
                            type='warning'
                            onClick={() => {
                                this.customizeDeleteModalWindow(user);
                                modalInstance.show();
                            }}>
                            {t('Delete')}
                        </DefaultButton>
                    </div>
                </td>
            </tr>
        )
    }

    render(): React.Node {
        const { t, projects, users } = this.props;
        return (
            <Table>
                <thead>
                    <tr>
                        <th>{t('User')}</th>
                        <th>{t('Role')}</th>
                        <th>{t('Projects')}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {users.map(user => {
                        return (this.renderRow(user, projects))
                    })}
                </tbody>
            </Table>
        )
    }
}

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance'),
    BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(UserList));


// WEBPACK FOOTER //
// ./src/containers/content/grid/adminPanel/userAdmin/userList/UserList.jsx